<template>
  <div>
    <CustomSelect
      ref="customSelect"
      multiple
      :list="list"
      :selectList="selectList"
      :customTreeList="customTreeList"
      @on-input-change="handleInputChange"
      @on-check-change="handleCheckChange"
      @on-delete-item="handleDeleteItem"
      @on-select-all="handleSelectAll"
    />
  </div>
</template>
<script>
import CustomSelect from '@/components/custom-select';
import util from '@/assets/js/util';
import _ from 'lodash';
export default {
  components: {
    CustomSelect
  },
  props: {
    roleId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      list: [],
      customTreeList: [],
      selectList: [],
      checkAll: false,
      userAuths: [],
      selectedIds: [],
      searchSetSelectIds: [],
      originSelectIds: [],
      selectGroupIds: [],
      originData: [],
      originUserData: [] // 用来提交时对比
    };
  },
  methods: {
    handleInputChange(value) {
      const cloneDeepTree = _.cloneDeep(this.customTreeList);
      let searcheTree = util.setRoleSelectIds(cloneDeepTree, this.selectedIds);
      if (!value) {
        searcheTree = util.setRoleSelectIds(cloneDeepTree, this.selectedIds);
      } else {
        searcheTree = util.personGetTreeList(searcheTree, value, this.selectedIds);
      }
      this.list = searcheTree;
    },
    handleCheckChange({ changeItem }) {
      // 如果是 group组
      let selectedIds = [...this.selectedIds];
      let selectGroupIds = [...this.selectGroupIds];
      if (changeItem.isGroup) {
        // 如果是选中状态
        let selectList = [...this.selectList];
        const selectListIds = this.selectList.map(i => i.id);
        if (changeItem.checked) {
          selectGroupIds = [...selectList, changeItem.id];
          this.selectGroupIds = selectGroupIds;
          if (changeItem.children && changeItem.children.length > 0) {
            // 如果是选中的部门，则筛选一下已经选中的，然后把未选中的选择上
            const filterChildren = changeItem.children.filter(
              i => !selectListIds.includes(i.id)
            );
            filterChildren.forEach(child => {
              if (!child.isGroup) {
                child.checked = true;
                selectedIds = [...selectedIds, child.id];
                selectList.push(child);
              }
            });
          }
        } else {
          // 如果是非选中状态
          selectGroupIds = selectGroupIds.filter(id => id != changeItem.id);
          this.selectGroupIds = selectGroupIds;
          if (changeItem.children && changeItem.children.length > 0) {
            // 把children 里面的 checked 改为 false
            const ids = [];
            changeItem.children.forEach(child => {
              if (!child.isGroup) {
                child.checked = false;
                selectedIds = selectedIds.filter(id => id != child.id);
                ids.push(child.id);
              }
            });
            selectList = selectList.filter(item => !ids.includes(item.id));
          }
        }
        this.selectList = selectList;
      } else {
        if (changeItem.checked) {
          const selectList = [...this.selectList, changeItem];
          selectedIds = [...selectedIds, changeItem.id];
          // 如果已经选中的数据和兄弟元素一样的话，就把父组件的checked=true
          if (changeItem.parentNode) {
            const childrenFilter = changeItem.parentNode.children.filter(
              item => !item.isGroup
            );
            const ids = selectList.filter(item => item.pid == changeItem.pid);
            if (childrenFilter.length == ids.length) {
              changeItem.parentNode.checked = true;
            }
          }
          this.selectList = selectList;
        } else {
          // 如果是单选并且是非选中，就把父级勾选取消
          // 需要把其他树节点的也选中
          selectedIds = selectedIds.filter(id => id != changeItem.id);
          if (changeItem.parentNode) {
            changeItem.parentNode.checked = false;
            selectGroupIds = [...selectGroupIds.filter(id => changeItem.parentNode.id != id)];
          }
          this.selectList = this.selectList.filter(
            item => item.id != changeItem.id
          );
        }
      }
      this.selectedIds = [...new Set(selectedIds)];
      util.setRoleSelectIds(this.list, this.selectedIds);
    },
    handleDeleteItem(item) {
      const obj = util.getCurrentData(this.list, item.id);
      obj.checked = false;
      if (obj.parentNode) {
        obj.parentNode.checked = false;
      }
      const selectedIds = this.selectedIds.filter(id => id != item.id);
      this.selectedIds = selectedIds;
      util.setRoleSelectIds(this.list, this.selectedIds);
      this.selectList = this.selectList.filter(i => i.id != item.id);
    },
    handleSelectAll({ checkAll }) {
      const {
        setSelectList,
        deleteSelectList,
        addSelectList
      } = util.roleUseCheckeAll(this.list, checkAll, this.selectList);
      let selectGroupIds = [];
      let selectList = [];
      let change = [];
      if (checkAll) {
        selectList = setSelectList;
        change = addSelectList;
        selectGroupIds = this.originData
          .filter(item => item.isGroup)
          .map(i => i.id);
      } else {
        // 筛选
        const ids = deleteSelectList.map(i => i.id);
        selectList = setSelectList.filter(item => !ids.includes(item.id));
        change = deleteSelectList;
        selectGroupIds = [];
      }
      const ids = selectList.map(i => i.id);
      this.selectedIds = ids;
      this.selectGroupIds = selectGroupIds;
      this.selectList = selectList;
    },
    init() {
      // 请求获取所有列表和已经保存过的人员
      let originSelectIds = [];
      const selectGroupIds = [];
      const currentUserId = JSON.parse(localStorage.userInfo).id;
      Promise.all([
        this.$ajax('/v1/departments/all', { domainType: 'orgApi' }),
        this.$ajax.post('/v1/role/roleUsers', { roleId: this.roleId })
      ]).then(([departAndPerson, roleUsers]) => {
        const { code: roleUsersCode, data: roleUsersData } = roleUsers.data;
        const {
          code: departAndPersonCode,
          data: departAndPersonData
        } = departAndPerson.data;
        if (departAndPersonCode == 200 && roleUsersCode == 200) {
          const { departments, users } = departAndPersonData;
          const userRoleUsersData = roleUsersData.filter(
            user => user != currentUserId
          );
          this.originUserData = [...userRoleUsersData];
          const selectedIds = userRoleUsersData;
          originSelectIds = userRoleUsersData;
          const userData = users
            .map(item => {
              const { departmentId, userId, realName, ...rest } = item;
              return {
                ...rest,
                id: userId,
                title: realName || item.userName,
                pid: departmentId,
                isGroup: false,
                checked: userRoleUsersData.includes(userId)
              };
            })
            .filter(user => user.id != currentUserId);
          const departmentData = departments.map(item => {
            const {
              childDepartmentId,
              childDepartmentName,
              departmentId,
              ...rest
            } = item;
            const currentUsers = userData.filter(
              user => user.pid == childDepartmentId
            );
            const checked =
              currentUsers.length > 0 &&
              currentUsers.every(user => user.checked);
            if (
              currentUsers.length > 0 &&
              currentUsers.every(user => user.checked)
            ) {
              selectGroupIds.push(item.childDepartmentId);
            }
            return {
              ...rest,
              id: childDepartmentId,
              title: childDepartmentName,
              pid: departmentId,
              isGroup: true,
              checked
            };
          });
          const originData = [...departmentData, ...userData];
          const treeData = util.getMenuTree(originData);
          const selectList = originData.reduce((pre, next) => {
            const hasId = pre.find(item => item.id == next.id);
            if (userRoleUsersData.includes(next.id) && !hasId) {
              pre.push(next);
            }
            return pre;
          }, []);
          this.list = [...treeData];
          this.customTreeList = [...treeData];
          this.selectList = selectList;
          this.selectedIds = selectedIds;
          this.originData = originData;
          this.originSelectIds = originSelectIds;
          this.selectGroupIds = selectGroupIds;
        }
      });
    },
    getUserAuth() {
      // 获取哪些变化了，
      // 通过原始数据和现在右侧的数据进行对比，把增了的或者减了的给记录下来
      const ids = this.selectList.map(item => item.id);
      // 去重
      const differenceIds = util.getArrDifference([...ids], [...this.originUserData]);
      const userAuths = differenceIds.map(changeId => ({
        id: changeId,
        authStatus: ids.includes(changeId)
      }));
      this.userAuths = userAuths;
    }
  },
  mounted() {
    this.init();
  },
  watch: {
    selectList: {
      deep: true,
      handler(newVal, oldVal) {
        this.list = _.cloneDeep(this.list);
        const ids = newVal.map(item => item.id);
        const customTreeList = util.setItemChecked(
          this.customTreeList,
          ids,
          this.selectGroupIds
        );
        this.customTreeList = customTreeList;
        this.getUserAuth();
      }
    },
    list: {
      deep: true,
      handler(newVal) {
        const checkedAll = util.checkAllSelect(newVal);
        this.$refs.customSelect.checkAll = checkedAll;
      }
    }
  }
};
</script>
<style></style>
